/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { PayloadAction } from "@reduxjs/toolkit";
import { IServiceDeviceData } from "../../api/devices/types";
import { IDeviceFilterState, IAllFiltersState } from "../types";

// ! TODO: This is not fully fleshed out yet,
//   this is mostly a placeholder for now, we will need additional properties,
//   for now this just building a list of unique hostnames and models from the
//   list of connected devices (we will use them to build the filter select lists).
export const buildDeviceFilterAction = (state: IDeviceFilterState, action: PayloadAction<IServiceDeviceData[]>) => {
  let deviceModels: string[] = [];
  let hostNames: string[] = [];
  action.payload.forEach((device) => {
    if (device.name && !hostNames.includes(device.name)) hostNames.push(device.name);
    if (device.modelName && !deviceModels.includes(device.modelName)) deviceModels.push(device.modelName);
  });

  state.deviceHostNames = [...hostNames].sort();
  state.deviceTypes = [...deviceModels].sort();
};

export const setSelectedDeviceSiteGroupAction = (state: IDeviceFilterState, action: PayloadAction<string>) => {
  state.selectedDeviceSiteGroup = action.payload;
};

export const setSelectedDeviceNameAction = (state: IDeviceFilterState, action: PayloadAction<string>) => {
  state.selectedDeviceName = action.payload;
};

export const setSelectedDeviceSiteAction = (state: IDeviceFilterState, action: PayloadAction<string>) => {
  state.selectedDeviceSite = action.payload;
};

export const setSelectedDeviceTypeAction = (state: IDeviceFilterState, action: PayloadAction<string>) => {
  state.selectedDeviceType = action.payload;
};

export const setSelectedSeverityTypeAction = (state: IDeviceFilterState, action: PayloadAction<string>) => {
  state.selectedSeverityType = action.payload;
};

export const setSelectedDeviceVersionAction = (state: IDeviceFilterState, action: PayloadAction<string>) => {
  state.selectedDeviceVersion = action.payload;
};

export const setSelectedDeviceStatusAction = (state: IDeviceFilterState, action: PayloadAction<string>) => {
  state.selectedDeviceStatus = action.payload;
};

export const setSelectedConfigGroupAction = (state: IDeviceFilterState, action: PayloadAction<string>) => {
  state.selectedConfigGroup = action.payload;
};

export const setSelectedDeviceConfigStatusAction = (state: IDeviceFilterState, action: PayloadAction<string>) => {
  state.selectedDeviceConfigStatus = action.payload;
};

export const setMaintenanceModeAction = (state: IDeviceFilterState, action: PayloadAction<string>) => {
  state.maintenanceMode = action.payload;
};

export const setSelectedDeviceKpiAction = (state: IDeviceFilterState, action: PayloadAction<string>) => {
  state.pmCollected = action.payload;
};

export const setSelectedLabelsAction = (state: IDeviceFilterState, action: PayloadAction<string[]>) => {
  state.selectedLabels = action.payload;
};

export const setRegionFilterIdsAction = (state: IDeviceFilterState, action: PayloadAction<string[]>) => {
  state.regionFilterIds = action.payload;
};

export const resetDeviceFiltersAction = (state: IAllFiltersState) => {
  state.selectedDeviceSiteGroup = "";
  state.selectedDeviceName = "";
  state.selectedDeviceSite = "";
  state.selectedDeviceType = "";
  state.selectedSeverityType = "";
  state.selectedDeviceStatus = "";
  state.selectedConfigGroup = "";
  state.selectedDeviceConfigStatus = "";
  state.selectedDeviceVersion = "";
  state.maintenanceMode = "";
  state.pmCollected = "";
  state.selectedLabels = [];
  state.regionFilterIds = [];
};
